import { render, staticRenderFns } from "./room.vue?vue&type=template&id=50beea30&scoped=true"
import script from "./room.vue?vue&type=script&lang=ts"
export * from "./room.vue?vue&type=script&lang=ts"
import style0 from "./room.vue?vue&type=style&index=0&id=50beea30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50beea30",
  null
  
)

export default component.exports